import { useCallback } from 'react';
import { Button, Card, Form, Input, Row, Space } from 'antd';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';

import { useResource } from 'app/common/api';
import { requiredRule } from 'app/common/form-helpers/features/rules';
import { NotificationsRender } from 'app/common/notifications/features/notifications';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/railways/router/routes';
import { Loading } from 'app/ui';

import { TPermission } from '../../../core/permissions';
import { TNewRole, TRole } from '../../../core/role';
import { AvailableRolePermissionsTransfer } from '../../../modules/available-role-permissions-transfer/available-role-permissions-transfer';
import { addRoleRequest } from '../../../requests/add-role.request';

type NewRoleFormFields = {
  title: string;
  name: string;
  permissions: TPermission[];
};

export const AddRoleFeature = observer(() => {
  const navigate = useNavigate();
  const notify = usePageNotify();

  const addRoleResource = useResource<TNewRole, TRole>({
    request: addRoleRequest,
    errorNotify: notify,
    onDone(createdRole) {
      const path = appRoute.ROLES.DETAILS.buildPath({
        roleId: createdRole.id,
      });

      navigate(path);
    },
  });

  const handleFormSubmit = useCallback(
    (person: NewRoleFormFields) => {
      addRoleResource.send(person);
    },
    [addRoleResource],
  );

  const isLoading = addRoleResource.isLoading;

  return (
    <>
      <Form
        layout="vertical"
        onFinish={handleFormSubmit}
        scrollToFirstError={{ behavior: 'smooth' }}
      >
        <Loading active={isLoading}>
          <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Card size="small" title="Данные роли">
              <Form.Item
                name="title"
                label="Название"
                rules={[requiredRule()]}
                style={{ maxWidth: '50%' }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="name"
                label="Идентификатор"
                rules={[requiredRule()]}
                style={{ maxWidth: '50%' }}
              >
                <Input />
              </Form.Item>
            </Card>

            <Card size="small" title="Разрешения для роли">
              <Form.Item name="permissions" label="" rules={[requiredRule()]}>
                <AvailableRolePermissionsTransfer />
              </Form.Item>
            </Card>

            <NotificationsRender notifyStore={notify} />

            <Card size="small">
              <Row>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginLeft: 'auto' }}
                >
                  Добавить роль
                </Button>
              </Row>
            </Card>
          </Space>
        </Loading>
      </Form>
    </>
  );
});
